import { Reducer } from 'redux';

import {
  DownloadCashTransactionsReportActions,
  DownloadCashTransactionsReportActionTypes,
} from '../actions/DownloadCashTransactionsReport';
import { IErrorActionData } from '../../../models/Error';

export interface IDownloadCashTransactionsReportState {
  requestId: string;
  isProcessing: boolean;
  isSuccess: boolean;
  error?: IErrorActionData;
}

const initialDownloadCashTransactionsReportState = {
  requestId: '',
  isProcessing: false,
  isSuccess: false,
  error: undefined,
} as IDownloadCashTransactionsReportState;

const DownloadCashTransactionsReportReducer: Reducer<IDownloadCashTransactionsReportState, DownloadCashTransactionsReportActions> = (
  state = initialDownloadCashTransactionsReportState,
  action: DownloadCashTransactionsReportActions,
): IDownloadCashTransactionsReportState => {
  switch (action.type) {
    case DownloadCashTransactionsReportActionTypes.DOWNLOAD_CASH_TRANSACTIONS_REPORT:
      return {
        ...state,
        isProcessing: true,
        isSuccess: false,
        error: undefined,
      };

    case DownloadCashTransactionsReportActionTypes.DOWNLOAD_CASH_TRANSACTIONS_REPORT_SUCCESS:
      return {
        ...state,
        requestId: action.payload.requestId,
        isProcessing: false,
        isSuccess: true,
        error: undefined,
      };

    case DownloadCashTransactionsReportActionTypes.DOWNLOAD_CASH_TRANSACTIONS_REPORT_FAILED:
      return {
        ...state,
        isProcessing: false,
        isSuccess: false,
        error: {
          errorCode: action.payload.errorCode,
          errorMessage: action.payload.errorMessage,
          callBack: action.payload.callBack,
        },
      };

    case DownloadCashTransactionsReportActionTypes.DOWNLOAD_CASH_TRANSACTIONS_REPORT_RESET:
      return initialDownloadCashTransactionsReportState;

    default:
      return state;
  }
};

export default DownloadCashTransactionsReportReducer;
